export type Board = string[][];

export enum Difficulty {
  dev = 'dev',
  easy = "easy",
  medium = "medium",
  hard = "hard",
  insane = "insane",
  grandpa = 'grandpa',
}

export enum GameState {
  startMenu = "startMenu",
  playing = "playing",
  pause = "pause",
  success = "success",
  wrong = "wrong",
}
